/** sessionStorage-only: other tabs cannot read this; avoids parallel-tab silent SSO during interactive login */
const ALLOW_MSAL_SHELL_THIS_TAB_SESSION_KEY =
  'ecrm-allow-msal-shell-this-tab' as const

/** sessionStorage-only: set when another tab finished login; allows silent SSO without credential prompt */
const ALLOW_CROSS_TAB_LOGIN_FOLLOW_SESSION_KEY =
  'ecrm-allow-msal-shell-cross-tab-follow' as const

export function allowMsalShellForThisTabAfterLogoutLogin(): void {
  try {
    sessionStorage.setItem(ALLOW_MSAL_SHELL_THIS_TAB_SESSION_KEY, '1')
  } catch {
    /* ignore */
  }
}

export function allowMsalShellForCrossTabLoginFollowAfterLogout(): void {
  try {
    sessionStorage.setItem(ALLOW_CROSS_TAB_LOGIN_FOLLOW_SESSION_KEY, '1')
  } catch {
    /* ignore */
  }
}

export function clearMsalShellAllowedThisTabMarker(): void {
  try {
    sessionStorage.removeItem(ALLOW_MSAL_SHELL_THIS_TAB_SESSION_KEY)
    sessionStorage.removeItem(ALLOW_CROSS_TAB_LOGIN_FOLLOW_SESSION_KEY)
  } catch {
    /* ignore */
  }
}

export function isMsalShellAllowedThisTabAfterLogoutLogin(): boolean {
  try {
    return sessionStorage.getItem(ALLOW_MSAL_SHELL_THIS_TAB_SESSION_KEY) === '1'
  } catch {
    return false
  }
}

export function isMsalShellAllowedForCrossTabLoginFollowAfterLogout(): boolean {
  try {
    return (
      sessionStorage.getItem(ALLOW_CROSS_TAB_LOGIN_FOLLOW_SESSION_KEY) === '1'
    )
  } catch {
    return false
  }
}
